module.exports = __webpack_public_path__ + "media/images/emblems/Buerchen-coat_of_arms-98d611f102b8eef872d84d0a7018256e.svg";